import { EmptyState } from "@closer/ui";

/**
 * Uygulama kabuğunun içeriği. Closer'ın ürün modülleri (sözleşme merkezi, şablonlar,
 * imza) henüz geliştirilmedi; bu ekran onlar gelene kadar dürüst bir boş durumdur.
 * Kartı olmayan hiçbir özellik burada gösterilmez.
 */
export function HomePage() {
  return (
    <EmptyState
      title="Henüz modül yok"
      description="Sözleşme modülleri geliştirildikçe bu alanda görünecek."
    />
  );
}
